<template>
    <z-animate-number value="29"></z-animate-number>
    <w-flex class="mb3">
        <w-card class="xs12 tanah-table-overflow">
            <w-spinner fade v-if="loading"></w-spinner>
            <table v-else class="mb2 table-dashboard">
                <thead>
                    <tr>
                        <th>Jenis Kutipan</th>
                        <th>Jumlah</th>
                        <th>DBB (RM)</th>
                        <th>DL (RM)</th>
                        <th>DY (RM)</th>
                        <th>DPT (RM)</th>
                        <th>DS (RM)</th>
                        <th>DP (RM)</th>
                        <th>DPS (RM)</th>
                        <th>DKS (RM)</th>
                        <th>DKM (RM)</th>
                        <th>DK (RM)</th>
                        <th>DKP (RM)</th>
                        <th>DB (RM)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-row-data" v-for="items in tableData.rows">
                        <template v-for="item in items">
                            <td class="tanah-table-data">{{ item }}</td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </w-card>
    </w-flex>

    <w-flex class="grow justify-space-betweenx basis-zero">
        <w-card class="mb3 mr3">
            <div>
                <w-flex class="justify-space-between">
                    <div class="dashboard-title">KUTIPAN HASIL CUKAI</div>
                </w-flex>
                <w-spinner fade v-if="loading"></w-spinner>
                <fusioncharts
                    v-else
                    :type="chart6.type"
                    :width="chart6.width"
                    :height="chart6.height"
                    :dataformat="chart6.dataFormat"
                    :dataSource="chart6.dataSource"
                >
                </fusioncharts>
            </div>
        </w-card>

        <w-card class="mb3 mr3">
            <w-flex class="justify-space-between">
                <div class="dashboard-title">
                    KUTIPAN PELBAGAI TERIMAAN DAN PINDAHAN
                </div>
            </w-flex>
            <w-spinner fade v-if="loading"></w-spinner>
            <fusioncharts
                v-else
                :type="chart7.type"
                :width="chart7.width"
                :height="chart7.height"
                :dataformat="chart7.dataFormat"
                :dataSource="chart7.dataSource"
            >
            </fusioncharts>
        </w-card>
    </w-flex>

    <w-flex class="grow justify-space-betweenx basis-zero">
        <w-card class="mb3 mr3">
            <w-flex class="justify-space-between">
                <div class="dashboard-title">KUTIPAN HASIL BUKAN CUKAI</div>
            </w-flex>
            <w-spinner fade v-if="loading"></w-spinner>
            <fusioncharts
                v-else
                :type="chart8.type"
                :width="chart8.width"
                :height="chart8.height"
                :dataformat="chart8.dataFormat"
                :dataSource="chart8.dataSource"
            >
            </fusioncharts>
        </w-card>
    </w-flex>
</template>
<script>
export default {
    props: {
        isActive: false
    },
    data() {
        return {
            loading: true,
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            tableData: {
                columns: [],
                rows: [],
            },
            chart6: {
                type: "column2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        showvalues: "1",
                        xaxisname: "Jenis Kutipan Hasil",
                        yaxisname: "Jumlah Kutipan Hasil",
                        numberprefix: "RM",
                        theme: "fusion",
                    },
                    data: [],
                },
            },
            chart7: {
                type: "column2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        showvalues: "1",
                        xaxisname: "Jenis Kutipan Hasil",
                        yaxisname: "Jumlah Kutipan Hasil",
                        numberprefix: "RM",
                        theme: "fusion",
                    },
                    data: [],
                },
            },
            chart8: {
                type: "column2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        showvalues: "1",
                        xaxisname: "Jenis Kutipan Hasil",
                        yaxisname: "Jumlah Kutipan Hasil",
                        numberprefix: "RM",
                        theme: "fusion",
                    },
                    data: [],
                },
            },
        };
    },
    methods: {
        async fetchData() {
            await axios
                .get(`${this.apiBaseUrl}/dashboard/daerah`)
                .then((resp) => {
                    const { table, barChart } = resp.data;
                    this.tableData.rows = table.rows;

                    this.chart6.dataSource.data = barChart.hasil_cukai;
                    this.chart7.dataSource.data = barChart.hasil_pelbagai;
                    this.chart8.dataSource.data = barChart.hasil_bukan_cukai;
                })
                .catch((err) => {
                    console.error(err);
                });
            this.rerender();
        },
        async rerender(){
            this.loading = true;
            await this.$nextTick();
            this.loading = false;
        }
    },
    mounted() {
        this.fetchData();
    },
    watch: {
        isActive(nv, ov) {
            if (nv) {
                this.rerender();
            }
        }
    },
};
</script>
<style>
.tanah-table-overflow {
    overflow: auto;
}

.tanah-table-data:nth-child(1) {
    font-weight: bold;
}

.tanah-table-data:nth-child(3n + 2) {
    background-color: rgba(247, 110, 17, 0.6);
}
.tanah-table-data:nth-child(3n + 3) {
    background-color: rgba(255, 159, 69, 0.6);
}
.tanah-table-data:nth-child(3n + 4) {
    background-color: rgba(166, 75, 42, 0.6);
}
</style>
